import { Toast } from '@base-ui/react/toast'
import { useTranslation } from 'react-i18next'

import { anchoredToastManager } from './notify'
import * as Styled from './anchoredToaster.styled'

import type { JSX } from 'react'

const AnchoredToastList = (): JSX.Element[] =>
  Toast.useToastManager().toasts.map((toast) => (
    <Styled.Positioner key={toast.id} toast={toast}>
      <Styled.Card toast={toast}>
        <Styled.Description />
      </Styled.Card>
    </Styled.Positioner>
  ))

export const AnchoredToaster = (): JSX.Element => {
  const { t } = useTranslation()

  return (
    <Toast.Provider toastManager={anchoredToastManager}>
      <Styled.Viewport aria-label={t('libs_toast_anchored_label')}>
        <AnchoredToastList />
      </Styled.Viewport>
    </Toast.Provider>
  )
}
